export const typeicons = {
  contenttype: 'assignment',
  content: 'insert_drive_file',
  webcontent: 'insert_drive_file',
  file: 'insert_drive_file',
  folder: 'folder',
  document: 'insert_drive_file',
  settings: 'settings',
  image: 'photo',
  resource: 'event_note',
  contentlist: 'view_list',
  aspect: 'assignment',
  domain: 'domain',
  orgunit: 'supervised_user_circle',
  smartfolder: 'folder_special',
  workspace: 'all_inbox',
  group: 'group',
  trash: 'delete',
  userprofile: 'person',
  formitem: 'input',
  calendarevent: 'event',
  link: 'link',
  query: 'library_books',
  workflow: 'shuffle'
};
//# sourceMappingURL=icons.js.map